import React from 'react'
import { string, func, number } from 'prop-types'

export default class StravaInputType extends React.Component {

	static displayName = 'InputListItem'
	static propTypes = {
		leftTitle: string,
		leftValue: string,
		rightTitle: string,
		rightValue: number,
		inputName: string,
		handleChange: func
	}

	render() {
		const { leftTitle, rightTitle, leftValue, rightValue, inputName, handleChange } = this.props
		return (
			<li>
				<span>
					<strong>{ leftTitle }</strong><br />
					{ leftValue }
				</span>
				<span>
					<strong>{ rightTitle }</strong><br />
					<input required type="number" step="0.01" placeholder="" name={ inputName } value={ rightValue } onChange={ handleChange } />
				</span>
			</li>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/StravaInputType/StravaInputType.js